<div [class]="'component-container h-full ' + (configObject?.callFrom || '')" *ngIf="!configObject || (configObject && !['dashboard', 'publishCollection'].includes(configObject.callFrom))">
  <cdk-virtual-scroll-viewport class="flex flex-row h-full" #scroller [itemSize]="itemHeight">
    <div class="image row pl-2 h-full" *cdkVirtualFor="let collectionList of collectionSplitList; let rowIndex = index">
      <ng-template ngFor let-collection [ngForOf]="collectionList" let-i="index">
        <div
          id="{{ rowIndex }}-{{ i }}"
          class="collection-asset-item card inline-block h-auto w-full"
          [ngClass]="{
            '!w-1/3': configObject && configObject.callFrom === 'dashboard',
            'half-width lg:!w-1/4 xl:!w-1/4 2xl:!w-1/4': !configObject && assetViewTypeService.getGridSettings('showGridViewSmall', gridSettingsKeySuffix),
            'sm:w-1/2 md:w-1/4 lg:w-[calc(100%/8)] xl:w-[calc(100%/8)] 2xl:w-[calc(100%/8)]': !configObject && assetViewTypeService.getGridSettings('showGridViewLarge', gridSettingsKeySuffix),
          }"
        >
          <div class="h-auto mr-6 mb-6 bg-white rounded-lg shadow-lg hover:shadow-xl relative">
            <div
              (click)="gotoAssetList(collection._id, true)"
              class="collection-asset-image-container asset-image-box"
              [ngClass]="{ 'cursor-pointer': !configObject || configObject.callFrom !== 'dashboard' }"
            >
              <img *ngIf="collection.coverAssetID?.imageUrl" class="collection-asset-image" [src]="collection.coverAssetID?.imageUrl | imageLoading | async" [alt]="collection.name" />
              <img *ngIf="!collection.coverAssetID?.imageUrl" class="collection-asset-image" src="assets/placeholder-collection.png" [alt]="collection.name" />
            </div>
            <!-- Keeping this checkbox after overlay component, so that it's visible  -->
            <div class="absolute top-4 left-4" *ngIf="configObject && configObject.callFrom === 'dashboard'">
              <p class="w-full truncate text-2xl">{{ collection.name }}</p>
            </div>
            <div class="collection-asset-checkbox-container" *ngIf="!configObject || configObject.callFrom !== 'dashboard'">
              <mat-checkbox *ngIf="false" class="example-margin" (change)="selectCollection.emit(collection)" [checked]="collection?.checked"> </mat-checkbox>
            </div>
            <div (click)="gotoAssetList(collection._id)" class="absolute underline top-16 left-4 cursor-pointer" *ngIf="configObject && configObject.callFrom === 'dashboard'">
              <p class="w-full truncate" i18n>Show more</p>
            </div>
            <div class="collection-asset-name-container" *ngIf="!configObject || configObject.callFrom !== 'dashboard'">
              <p class="w-full truncate">{{ collection.name }}</p>
            </div>
            <div class="flex justify-between pb-1" *ngIf="!configObject || configObject.callFrom !== 'dashboard'">
              <div class="flex justify-center items-center ml-3 relative">
                <span (click)="$event.stopPropagation()" [matBadge]="collection.assets?.length" matBadgeOverlap="false">
                  <mat-icon class="material-icons-outlined">perm_media</mat-icon>
                </span>
              </div>
              <thehubz-collection-card-view-actions
                [assetDetails]="assetDetails"
                [configObject]="configObject"
                [collection]="collection"
                (editCollection)="editCollection($event)"
                (downloadCollection)="downloadCollection($event)"
                (publishCollection)="publishCollection($event)"
                (shareCollection)="shareCollection($event)"
                (deleteCollection)="deleteCollection($event)"
                (unpublishCollection)="unpublishCollection($event)"
              ></thehubz-collection-card-view-actions>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </cdk-virtual-scroll-viewport>
</div>

@if (configObject && ['dashboard', 'publishCollection'].includes(configObject.callFrom)) {
  <div [class]="'component-container ' + (configObject.callFrom || '')">
    @if (screenSizeDetectorService.isSmallScreen) {
      <swiper-container #slider init="false">
        @for (collection of collectionList; track collection._id; let index = $index) {
          <swiper-slide>
            <ng-container *ngTemplateOutlet="collectionWidget; context: { collection }"></ng-container>
          </swiper-slide>
        }
      </swiper-container>

      <div class="custom-swiper-pagination" [ngClass]="{ hidden: !needSliderPagination }"></div>
    } @else {
      @for (collection of collectionList; track collection._id; let index = $index) {
        <ng-container *ngTemplateOutlet="collectionWidget; context: { collection }"></ng-container>
      }
    }
  </div>
}

<ng-template #collectionWidget let-collection="collection">
  <div class="collection-asset-item card">
    <div class="h-auto mr-6 mb-6 bg-white rounded-lg shadow-lg hover:shadow-xl relative">
      <div
        (click)="gotoAssetList(collection._id, true)"
        class="collection-asset-image-container asset-image-box w-full flex items-center rounded-lg overflow-hidden"
        [ngClass]="{ 'cursor-pointer': !configObject || configObject.callFrom !== 'dashboard' }"
      >
        <img *ngIf="collection.coverAssetID?.imageUrl" class="collection-asset-image" [src]="collection.coverAssetID?.imageUrl | imageLoading | async" [alt]="collection.name" />
        <img *ngIf="!collection.coverAssetID?.imageUrl" class="collection-asset-image" src="assets/placeholder-collection.png" [alt]="collection.name" />
      </div>
      <!-- Keeping this checkbox after overlay component, so that it's visible  -->
      <div class="collection-asset-content">
        <h3 class="collection-asset-name">{{ collection.name }}</h3>
        <ng-container *ngIf="configObject && configObject.callFrom === 'dashboard'">
          <button class="w-full truncate cursor-pointer" (click)="gotoAssetList(collection._id)" i18n>Show more</button>
        </ng-container>
      </div>

      <div class="flex justify-between pb-1" *ngIf="!configObject || configObject.callFrom !== 'dashboard'">
        <div class="flex justify-center items-center ml-3 relative">
          <span (click)="$event.stopPropagation()" [matBadge]="collection.assets?.length" matBadgeOverlap="false">
            <mat-icon class="material-icons-outlined">perm_media</mat-icon>
          </span>
        </div>
        <div class="flex justify-between pb-1">
          <div *ngIf="!['shareCollection', 'publishCollection'].includes(configObject?.callFrom || '')">
            <span class="cursor-pointer">
              <button
                *ngIf="!assetDetails && (AnyAsset | can: 'download')"
                mat-icon-button
                type="button"
                (click)="downloadCollection(collection._id); $event.stopPropagation()"
                i18n-matTooltip
                matTooltip="Download collection"
              >
                <mat-icon class="material-icons-outlined">file_download</mat-icon>
              </button>
            </span>
            <span class="cursor-pointer">
              <button
                *ngIf="!assetDetails && (AnyAsset | can: 'share')"
                mat-icon-button
                type="button"
                (click)="shareCollection(collection._id); $event.stopPropagation()"
                i18n-matTooltip
                matTooltip="Share collection"
              >
                <mat-icon class="material-icons-outlined">share</mat-icon>
              </button>
            </span>
            <span class="cursor-pointer">
              <button
                *ngIf="!assetDetails && (AnyAsset | can: 'delete')"
                mat-icon-button
                type="button"
                (click)="deleteCollection(collection._id); $event.stopPropagation()"
                i18n-matTooltip
                matTooltip="Delete collection"
              >
                <mat-icon class="material-icons-outlined">delete_outline</mat-icon>
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
